import React from 'react';
import { apiService } from '../../services/api';
import { useLocale } from '../../contexts/LocaleContext';
import { DocumentModal } from './DocumentModal';

interface Props {
  quotation: { _id: string; quotationNumber?: string; customer?: { name?: string; phone?: string; email?: string } } | null;
  onClose: () => void;
}

/** Quotation PDF with a chosen template and language, then open, email or send it on WhatsApp. */
export const QuotationDocumentModal: React.FC<Props> = ({ quotation, onClose }) => {
  const { t } = useLocale();
  if (!quotation) return null;
  return (
    <DocumentModal
      visible
      types={['quotation']}
      scopeLabel={t('documents.forQuotation', { number: quotation.quotationNumber || '' })}
      recipient={{ name: quotation.customer?.name, phone: quotation.customer?.phone, email: quotation.customer?.email }}
      sendSource={{ quotationId: quotation._id }}
      onClose={onClose}
      onGenerate={async (req) => {
        const res = await apiService.generateQuotationDocument(quotation._id, { templateId: req.templateId, language: req.language, userLocale: req.userLocale, hideCustomerPhone: req.hideCustomerPhone });
        if (res.statusCode !== 1000 || !res.data) throw new Error((res as any).message || res.errors?.[0]?.message || t('documents.failed'));
        return res.data;
      }}
    />
  );
};
